<template>
    <div class="hero is-large">
        <div class="hero-body">
            <div class="container">
                <h1 class="title">
                    logan's Barbershop
                </h1>
<!--                <h1 class="subtitle">-->
<!--                    Leamington Spa-->
<!--                </h1>-->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'banner'
    }

</script>
<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Major+Mono+Display');
    @import url('https://fonts.googleapis.com/css?family=Thasadith');


    h4 {
        font-family: 'Major Mono Display', monospace;
        font-weight: 300;
        font-size: 1.5rem;

    }

    .title {

        font-family: 'Major Mono Display', monospace;
        color: white;
        font-weight: 900;
        font-size: 3rem;

    }

    .subtitle {

        color: white;
        font-family: 'Thasadith', sans-serif;
        font-size: 1.25rem;
        margin-left: 0.4rem;

    }

    .hero {

        background-image: url('../assets/logan-hero.jpg');
        background-size: cover;
        /*opacity: 0.6;*/

    }

    @media only screen and (max-width: 768px) {

        .title {

            font-size: 1.25rem;

        }

        .subtitle {

            font-size: 0.75rem;

        }

    }

</style>
